export type SettingsOrigin = 'response' | 'frame';

export const CLINICAL_EVENTS_DISPLAY_OPTIONS = [
  'checkpoints',
  'dots',
  'hidden',
] as const;

export type ClinicalEventsDisplay =
  (typeof CLINICAL_EVENTS_DISPLAY_OPTIONS)[number];

export const isClinicalEventsDisplay = (
  value: unknown,
): value is ClinicalEventsDisplay =>
  CLINICAL_EVENTS_DISPLAY_OPTIONS.some(option => option === value);

export const DEFAULT_CLINICAL_EVENTS_DISPLAY: ClinicalEventsDisplay = 'dots';

export type GlobalSettingSource = 'configured' | 'unset' | 'code';

export interface GlobalSetting {
  key: string;
  value: unknown;
  source: GlobalSettingSource;
  /** The built-in value, when the payload carries it. */
  default?: unknown;
  updatedAt: string | null;
  updatedBy: string | null;
  drift: boolean;
}

export interface GlobalSettings {
  settings: GlobalSetting[];
  ts: number;
}

export interface UserParameter {
  key: string;
  value: unknown;
  default: unknown;
  overridden: boolean;
  updatedAt: string | null;
  drift: boolean;
}

export interface UserParameters {
  parameters: UserParameter[];
  ts: number;
}

export interface SettingsFrame extends GlobalSettings {
  kind: 'settings';
}

export interface UserParametersFrame extends UserParameters {
  kind: 'userParameters';
}

export interface SettingViolation {
  path: string;
  constraint: string;
  bound?: number | readonly string[];
}

/** One allow-listed echo queue, as the admin read lists it, in env order. */
export interface EchoQueue {
  url: string;
  name: string;
  enabled: boolean;
  /** Null when the worker's last check read no count, so it is not a zero. */
  backlog: number | null;
}
